/** Ten national digits of a Russian mobile number, typed or pasted in any common form. */
export function phoneDigits(value: string): string {
  const raw = value;
  let digits = raw.replace(/\D/g, '');
  if (raw.trim().startsWith('+7')) digits = digits.slice(1);
  else if (digits.length === 11 && (digits[0] === '7' || digits[0] === '8'))
    digits = digits.slice(1);
  return digits.slice(0, 10);
}

/** "+7 916 245-18-30" progressively while typing. */
export function formatPhone(digits: string): string {
  if (!digits) return '';
  let result = `+7 ${digits.slice(0, 3)}`;
  if (digits.length > 3) result += ` ${digits.slice(3, 6)}`;
  if (digits.length > 6) result += `-${digits.slice(6, 8)}`;
  if (digits.length > 8) result += `-${digits.slice(8, 10)}`;
  return result;
}

export function isValidMobile(digits: string): boolean {
  return /^9\d{9}$/.test(digits);
}

export function toE164(digits: string): string {
  return `+7${digits}`;
}
